import ConnectionService, { HttpMethod } from './connection.service';
import ISession from '../../models/session.model';
import { IBucket } from '../../models/ bucket.model';
import ILog from '../../models/log.model';
import ILogChat from '../../models/logchat.model';

class LogConnection {  
  // A flow also returns its rows flat in display order; its sessions then carry no logs.
  public async getSessionLogs(data: object): Promise<{sessions: ISession[], logs?: ILog[], buckets?: IBucket[], nextCursor?: string}> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/sessions/logs`, HttpMethod.GET, data);
  }

  public getSessionLogsUrl(data: object) {
    return `${ConnectionService.appUrl}/sessions/logs?${ConnectionService.encodeQueryData(data)}`;
  }

  public async getSessions(data: object): Promise<ISession[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/sessions`, HttpMethod.GET, data);
  }
  
  public async getAppVersions(appVersion: string): Promise<string[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/sessions/appVersions`, HttpMethod.GET,  {q: appVersion});
  }

  public async getTags(tag: string): Promise<string[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/logs/tags`, HttpMethod.GET,  {q: tag});
  }

  public async getOsVersions(osVersion: string): Promise<string[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/logs/osVersions`, HttpMethod.GET,  {q: osVersion});
  }

  public async getClassNames(className: string): Promise<string[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/logs/classNames`, HttpMethod.GET,  {q: className});
  }

  public async getAdditionalParams(): Promise<string[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/sessions/additionalParams`, HttpMethod.GET);
  }

  public async getLinkedApps(sessionId: string): Promise<{app: string, sessionId: string}[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/sessions/${sessionId}/linkedApps`, HttpMethod.GET);
  }

  public async getLogs(data: object): Promise<ILog[]>{
    const response = await ConnectionService.fetch(`${ConnectionService.appUrl}/logs`, HttpMethod.GET, data);
    return response.logs;
  }
}

export default new LogConnection();